import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

export interface ITransporterLogin {
  email?: string;
  password?: string;
  token?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor() { }

  private readonly loginSubject: BehaviorSubject<ITransporterLogin | null> = new BehaviorSubject<ITransporterLogin | null>(null);

  updateTransporter(changes: Partial<ITransporterLogin>): void {
    this.loginSubject.next({
    ...this.loginSubject.value,
    ...changes
    });
  }

  getValues(): ITransporterLogin {
    return this.loginSubject.getValue() || {} as ITransporterLogin;
  }

  reset(): void {
    this.loginSubject.next(null);
  }

}
